<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 背景装饰圆点 -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute top-20 left-20 w-16 h-16 bg-psychology-primary-20 rounded-full animate-float"></div>
      <div class="absolute top-40 right-32 w-20 h-20 bg-psychology-warning-20 rounded-full animate-float-delay-1"></div>
      <div class="absolute bottom-40 left-1/4 w-12 h-12 bg-psychology-primary-30 rounded-full animate-float-delay-2"></div>
      <div class="absolute bottom-32 right-20 w-14 h-14 bg-psychology-accent-20 rounded-full animate-float"></div>
    </div>

    <div class="relative z-10">
      <!-- 导航栏 -->
      <NavBar />

      <!-- 主要内容 -->
      <main class="container mx-auto px-4 pb-20">
        <!-- Hero区域 -->
        <HeroSection />

        <!-- 七大维度 -->
        <DimensionsSection />

        <!-- 隐私保护 -->
        <PrivacySection />

        <!-- CTA区域 -->
        <CTASection />
      </main>

      <!-- 页脚 -->
      <FooterSection />
    </div>

    <!-- 回到顶部按钮 -->
    <BackToTop />
  </div>
</template>

<script>
import NavBar from './NavBar.vue'
import HeroSection from './HeroSection.vue'
import DimensionsSection from './DimensionsSection.vue'
import PrivacySection from './PrivacySection.vue'
import CTASection from './CTASection.vue'
import FooterSection from './Footer.vue'
import BackToTop from './BackToTop.vue'
import { saveActivationCode } from '@/utils/activationUtils'

export default {
  name: 'HomePage',
  components: {
    NavBar,
    HeroSection,
    DimensionsSection,
    PrivacySection,
    CTASection,
    FooterSection,
    BackToTop
  },
  mounted() {
    // 检查 URL 参数中是否有 r 参数
    this.checkUrlActivationCode()
  },
  methods: {
    /**
     * 检查 URL 参数中的激活码
     * 如果存在 r 参数，直接保存到缓存，不需要验证
     */
    checkUrlActivationCode() {
      const urlParams = new URLSearchParams(window.location.search)
      const rParam = urlParams.get('r')
      
      if (rParam && rParam.trim()) {
        // 保存 URL 参数中的激活码，类型为 'url'
        const success = saveActivationCode(rParam.trim(), 'url')
        if (success) {
          console.log('已从 URL 参数保存激活码')
          // 可选：清除 URL 参数，避免在地址栏显示
          // 注意：这里不自动清除，保留在 URL 中以便用户看到
        }
      }
    }
  }
}
</script>

<style scoped>
@keyframes float {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  50% {
    transform: translateY(-20px) translateX(10px);
  }
}

@keyframes float-delay-1 {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  50% {
    transform: translateY(-30px) translateX(-15px);
  }
}

@keyframes float-delay-2 {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  50% {
    transform: translateY(-25px) translateX(20px);
  }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-float-delay-1 {
  animation: float-delay-1 7s ease-in-out infinite;
}

.animate-float-delay-2 {
  animation: float-delay-2 8s ease-in-out infinite;
}
</style>

